module.exports = __webpack_public_path__ + "img/6_53.3ea17c58.png";